import styled from 'styled-components';

const FormLabel = styled.label`
  font-size: 1rem;
  font-weight: 600;
`;

export default FormLabel;
